/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-support-api-client";
import type { BulkUploadLtxFilesMutationRequest, BulkUploadLtxFilesMutationResponse } from "../models/BulkUploadLtxFiles";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { bulkUploadLtxFiles } from "../axios/bulkUploadLtxFiles";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const bulkUploadLtxFilesMutationKey = () => ["audit-support-api", { url: '/ltx-files/bulk-upload' }] as const

export type BulkUploadLtxFilesMutationKey = ReturnType<typeof bulkUploadLtxFilesMutationKey>

export function bulkUploadLtxFilesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BulkUploadLtxFilesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = bulkUploadLtxFilesMutationKey()
        return mutationOptions<BulkUploadLtxFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadLtxFilesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return bulkUploadLtxFiles(data, config)
          },
        })

}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload LTX files
 * {@link /ltx-files/bulk-upload}
 */
export function useBulkUploadLtxFiles<TContext>(options: 
{
  mutation?: UseMutationOptions<BulkUploadLtxFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadLtxFilesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BulkUploadLtxFilesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? bulkUploadLtxFilesMutationKey()

          const baseOptions = bulkUploadLtxFilesMutationOptions(config) as UseMutationOptions<BulkUploadLtxFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadLtxFilesMutationRequest}, TContext>
          

          return useMutation<BulkUploadLtxFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadLtxFilesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BulkUploadLtxFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadLtxFilesMutationRequest}, TContext>
      
}